import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=23bcf03a&scoped=true"
import script from "./Company.vue?vue&type=script&lang=js"
export * from "./Company.vue?vue&type=script&lang=js"
import style0 from "./Company.vue?vue&type=style&index=0&id=23bcf03a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bcf03a",
  null
  
)

export default component.exports